import { render, staticRenderFns } from "./CourseClassicEnrollmentTile.vue?vue&type=template&id=581f53f1&scoped=true&"
import script from "./CourseClassicEnrollmentTile.vue?vue&type=script&lang=js&"
export * from "./CourseClassicEnrollmentTile.vue?vue&type=script&lang=js&"
import style0 from "./CourseClassicEnrollmentTile.vue?vue&type=style&index=0&id=581f53f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f53f1",
  null
  
)

export default component.exports